import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_MEMBERSHIP_STRIPE_PAYMENT_ELEMENTS = defineFcm('revenue_membership_stripe_payment_elements')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Membership Join Page',
		description: 'This config is used to gate the use of Stripe Payment Elements on the Membership Join Page',
		template: {
			enabled: false,
			experimentName: '',
		},
	});
